import { useCallback, useEffect, useState } from "react";
import { getFaqs } from "../../../../services/StudentPortal/StudentFaqService";
import { unwrapList } from "../../utils/studentPortalUtils";
import { handleApiError } from "../../../../utils/errorHandler";

// Loads the FAQ list once on mount. Keeps the hook dumb on purpose: the
// accordion open/close state lives in StudentFaq.js, not here.
export const useStudentFaq = (params) => {
  const [faqs, setFaqs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchFaqs = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getFaqs(params);
      setFaqs(unwrapList(response));
    } catch (error) {
      handleApiError(error);
      setFaqs([]);
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchFaqs();
  }, [fetchFaqs]);

  return { faqs, isLoading };
};

export default useStudentFaq;
